// --- Order Status (OrdStat) Mapping ---
// Updated ordStatLabels map
export const ordStatLabels = {
    0: "입금대기",
    1: "접수대기",
    2: "대체입금",
    10: "접수진행",
    12: "상담대기",
    20: "생산진행",
    30: "생산완료",
    70: "출고대기",
    80: "출고완료",
    90: "주문취소",
};
/**
 * OrdStat 코드를 해당하는 한글 설명으로 매핑합니다.
 * @param ordStat OrdStat 코드.
 * @returns 해당하는 한글 설명 또는 코드를 문자열로 변환한 값.
 */
export function getOrdStatLabel(ordStat) {
    // Ensure ordStat is treated as a number for map lookup
    const numericOrdStat = typeof ordStat === "number" ? ordStat : undefined;
    return numericOrdStat !== undefined && ordStatLabels[numericOrdStat]
        ? ordStatLabels[numericOrdStat]
        : String(ordStat ?? "알 수 없음");
}
export const fileErrorTypesLabels = {
    "파일에러-그룹에러": "그룹에러",
    "파일에러-테두리선에러": "테두리선에러",
    "파일에러-폰트아웃라인에러": "폰트아웃라인에러",
    "파일에러-프로그램버전에러": "프로그램버전에러",
    "파일에러-칼선없음": "칼선없음",
    "파일에러-데이타누락": "데이타누락",
    "파일에러-사이즈에러": "사이즈에러",
    "파일에러-건수불일치": "건수불일치",
    "파일에러-양단면접수에러": "양단면접수에러",
    "파일에러-이미지유실": "이미지유실",
    "파일에러-기타": "기타",
};
export const jobStatLabels = {
    100: "접수대기",
    109: "파일에러",
    112: "교정대기",
    113: "접수보류",
    116: "디자인완료",
    120: "견적수정",
    121: "파일에러-그룹에러",
    122: "파일에러-테두리선에러",
    123: "파일에러-폰트아웃라인에러",
    124: "파일에러-프로그램버전에러",
    125: "파일에러-칼선없음",
    126: "파일에러-데이타누락",
    127: "파일에러-사이즈에러",
    128: "파일에러-건수불일치",
    129: "파일에러-양단면접수에러",
    130: "파일에러-이미지유실",
    131: "파일에러-기타",
    196: "디자인대기",
    197: "가공대기",
    198: "가공완료",
    199: "조판대기",
    200: "출력대기",
    201: "인쇄대기",
    202: "출고대기",
    101: "접수완료",
    102: "업로드완료",
    103: "조판완료",
    104: "출력완료",
    105: "인쇄완료",
    117: "입고완료",
    106: "출고완료",
    108: "배송완료",
    114: "주문취소",
    115: "삭제",
    203: "출고취소",
    215: "출고후 취소",
};
/**
 * JobStat 코드를 해당하는 한글 설명으로 매핑합니다.
 *
 * @param jobStat JobStat 코드.
 * @returns 해당하는 한글 설명 또는 코드를 문자열로 변환한 값.
 */
export function getJobStatLabel(jobStat) {
    return jobStat !== undefined && jobStatLabels[jobStat]
        ? jobStatLabels[jobStat]
        : String(jobStat ?? "알 수 없음");
}
export const dlvyStatLabels = {
    0: "생산중",
    1: "출고대기",
    2: "출고완료",
    9: "출고취소",
};
/**
 * DlvyStat 코드를 해당하는 한글 설명으로 매핑합니다.
 *
 * @param dlvyStat DlvyStat 코드.
 * @returns 해당하는 한글 설명 또는 코드를 문자열로 변환한 값.
 */
export function getDlvyStatLabel(dlvyStat) {
    const numericDlvyStat = typeof dlvyStat === "number" ? dlvyStat : undefined;
    return numericDlvyStat !== undefined && dlvyStatLabels[numericDlvyStat]
        ? dlvyStatLabels[numericDlvyStat]
        : String(dlvyStat ?? "알 수 없음");
}
export const dlvyMCDLabels = {
    0: "방문",
    1: "배쑝와쑝",
    2: "대리배송",
    3: "착불택배",
    4: "선불택배",
    5: "화물",
    6: "착불퀵",
    7: "선불퀵",
    8: "고속버스",
    9: "항공배송",
    10: "선박배송",
};
/**
 * DlvyMCD 코드를 해당하는 한글 설명으로 매핑합니다.
 *
 * @param dlvyMCD DlvyMCD 코드.
 * @returns 해당하는 한글 설명 또는 코드를 문자열로 변환한 값.
 */
export function getDlvyMCDLabel(dlvyMCD) {
    const numericDlvyMCD = typeof dlvyMCD === "number" ? dlvyMCD : undefined;
    return numericDlvyMCD !== undefined && dlvyMCDLabels[numericDlvyMCD]
        ? dlvyMCDLabels[numericDlvyMCD]
        : String(dlvyMCD ?? "알 수 없음");
}
